<template>

  <div id="app">
    <div >
      <search-bar ref="searchBarComponent" @searchBarHeight="getSearchBarHeight">

        <div slot="search-cont">

          <div class="item" style="width: 530px;" >
            <div class="item-label">关键词搜索</div>
            <div style="width: 430px;">
              <el-input placeholder="请输入内容" v-model="key" class="input-with-select" size="small" @keyup.enter.native='searchResume'>
                <el-select v-model="key_type" slot="prepend" placeholder="请选择" @change="selectChange" style="width: 130px"
                  size="small">
                  <el-option label="工厂名称" value="1"></el-option>
                  <el-option label="驻厂" value="2"></el-option>
                  <el-option label="电话" value="3"></el-option>
                  <el-option label="邮箱" value="4"></el-option>
                  <el-option label="地址" value="5"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
              </el-input>
            </div>
          </div>
          <!--  操作按钮 start -->
            <div class="item">
              <el-button class="item-btn" type="primary" @click="getCompany">查询</el-button>
              <el-button class="item-btn reset-btn" @click="clearQuery">重置</el-button>
            </div>
          <!--  操作按钮 end -->

        </div>

      </search-bar>

      <div class="l-panel">
        <div class="panel-body">
          <el-table class="l-table l-table-new-nooperator" :max-height="300" :data="companyList" stripe style="width: 100%;" size="mini">
            <el-table-column prop="companyname" label="招聘工厂名称(简称)" align="left" width="200"> </el-table-column>
            <el-table-column label="订单类型" align="left" width="110">
              <template slot-scope="{row}">
               {{row.businesstype==1?"一手单":(row.businesstype==2?"二手单":"")}}
              </template>
            </el-table-column>
            <el-table-column prop="telephone" label="电话" align="left" width="120"> </el-table-column>
            <el-table-column prop="email" label="邮箱" align="left" width="180"> </el-table-column>
            <el-table-column prop="oausername" label="驻厂" align="left" width="120"> </el-table-column>
            <el-table-column prop="address" label="地址" align="left" >
              <template slot-scope="{ row }">

                <el-tooltip v-if="row.address" style="width: 100px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align:left;" effect="dark" placement="right">
                  <div style="width: 150px;" slot="content">{{row.address || "-"}}</div>
                  <el-button type="text" style="color: #666;">{{row.address.substring(0,15)}}</el-button>
                </el-tooltip>
                <span v-else >{{ row.address || "-" }}</span>
              </template>

            </el-table-column>
            <el-table-column prop="addtime" label="添加时间" align="left" width="140"> </el-table-column>
            <el-table-column prop="cooperate_companyname" label="合同工厂" align="left" width="200"> </el-table-column>
            <el-table-column prop="contract" label="合同" align="left" width="180">
              <template slot-scope="{row}">
                <div v-for="(citem,cindex) in row.contract" :key="cindex">{{citem}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="操作" align="right" width="300px">
              <template slot-scope="{row}">

                  <el-button type="text" size="mini" @click="setWorkTime(row)"><i class="el-icon-alarm-clock"></i>工作时间</el-button>
                  <el-button type="text" size="mini" @click="handleEdit(row.id)"><i class="el-icon-edit-outline"></i>编辑</el-button>
                  <el-link type="danger" size="mini" @click='handleDele(row.id,row.companyname)'><i class="el-icon-close"></i>删除</el-link>
                  <el-button type="text" size="mini" @click="showPriceDialog(row)"><i class="el-icon-edit-outline"></i>服务费</el-button>

              </template>
            </el-table-column>

          </el-table>

          <div class="c-table-pager">
            <el-pagination @current-change="handleCurrentChange" :total="total"></el-pagination>
          </div>
        </div>
      </div>



      <el-dialog title="工作时间" :visible.sync="dialogVisible" width="100%">
        <el-form  :model="form" class="demo-form-inline" :inline="true" ref="form">
         <el-form-item label="工作制度" prop='resttype' :rules="[{type: 'array', required: true, message: '请至少选择一个工作制度', trigger: 'change'}]">
           <el-checkbox-group v-model="form.resttype">
             <el-checkbox label="1">双休</el-checkbox>
             <el-checkbox label="2">单休</el-checkbox>
             <el-checkbox label="3">大小周</el-checkbox>
           </el-checkbox-group>
         </el-form-item>
          <el-form-item>
            <el-button type="primary" size='mini' @click="submitForm('form')">保存</el-button>
            <el-button type="primary" size='mini' @click="addTimes">新增上班时间</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="workhours" align="center" label="每日工作时间" width="180"></el-table-column>
          <el-table-column prop="workbegin" align="center" label="上班时间" width="180"></el-table-column>
          <el-table-column prop="workend" align="center" label="下班时间" width="180"></el-table-column>
          <el-table-column prop="address" align="center" label="操作">
            <template slot-scope='{row}'>
              <el-button type="danger" size='mini' @click='deleteTime(row)'>删除</el-button>
              <el-button type="primary" size='mini' @click='editInfo(row)'>编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog :title="dynamicValidateForm.timeid ? '修改工作时间':'新增工作时间'" :visible.sync="dialogVisibles" width="100%">
            <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="dynamicClass">
              <el-form-item label="工作时间" prop="workhours" :rules="[{ required: true, message: '工作时间不能为空', trigger: 'blur'},
                { type: 'number', message: '工作时间必须为数字值', trigger: 'blur'}]">
                <el-input v-model="dynamicValidateForm.workhours" @blur='formatValue($event)'></el-input>
              </el-form-item>
              <el-form-item label="上班时间" prop="workbegin" :rules="[{required:true,message:'请选择上班时间',trigger:'change'}]">
                <el-time-select  v-model="dynamicValidateForm.workbegin"
                :picker-options="{start: '00:00',step: '00:05',end: '24:00'}" placeholder="选择上班时间">
                </el-time-select>
              </el-form-item>
              <el-form-item label="下班时间" :rules="[{required:true,message:'请选择上班时间',trigger:'change'}]" prop="workend">
                <el-time-select    v-model="dynamicValidateForm.workend"
                 :picker-options="{start: '00:00',step: '00:05',end: '24:00'}" placeholder="选择下班时间"></el-time-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('dynamicValidateForm')">提交</el-button>
              </el-form-item>
            </el-form>
      </el-dialog>

      <el-dialog class="el-dialog-larger" title="服务费" :visible.sync="dialogVisiblePrice" >
        <el-col :span="10" style="margin-right: 30px;">
          <el-form  :model="priceForm" label-width="100px"  ref="priceForm">
           <el-form-item label="公司名称" >
             <el-input v-model="priceForm.name" disabled></el-input>
           </el-form-item>
           <el-form-item label="服务费" prop='service_price' :rules="[{ required: true, message: '请输入服务费', trigger: 'blur'}]">
             <el-input type="number" v-model="priceForm.service_price"><template slot="append">小时/元</template></el-input>
           </el-form-item>
             <el-form-item label="有效时间" required>
               <el-col :span="11">
                 <el-form-item prop="start_date" :rules="[{ required: true, message: '请选择起始日期', trigger: 'change'}]">
                   <el-date-picker type="date" placeholder="选择起始日期" v-model="priceForm.start_date" value-format="yyyy-MM-dd"  style="width: 100%;"></el-date-picker>
                 </el-form-item>
               </el-col>
               <el-col class="line" :span="2">-</el-col>
               <el-col :span="11">
                 <el-form-item prop="end_date" :rules="[{ required: true, message: '请选择结束日期', trigger: 'change'}]">
                   <el-date-picker placeholder="选择结束日期" v-model="priceForm.end_date" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                 </el-form-item>
               </el-col>
             </el-form-item>
            <el-form-item>
              <el-button type="primary"  @click="submitFormPrice('priceForm')">保存</el-button>

            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="13">
          <div class="l-panel">
              <div class="panel-body">
                <div>历史记录</div>
                <el-table class="l-table" :data="priceDataList" style="width: 100%">
                  <el-table-column  align="center" prop="service_price" label="服务费" width="80px" ></el-table-column>
                  <el-table-column  align="center" label="有效时间" >
                    <template slot-scope='{row}'>
                      {{row.start_date}} - {{row.end_date}}
                    </template>
                  </el-table-column>
                  <el-table-column  align="center" label="操作时间" prop="addtime" ></el-table-column>
                  <el-table-column  align="center" label="操作人" prop="admin_name" ></el-table-column>
                </el-table>
              </div>
          </div>

        </el-col>


      </el-dialog>

    </div>



  </div>

</template>

<script>
  import {
    WebUrl
  } from '@/api/index';
  import Message from '@/utils/message.js';
  export default {
    data: function() {
      return {
        companyList: [],
        key: '', //关键字搜索
        key_type: '', //关键字类型：
        page: 1, //页码
        total: 1,
        host: process.env.API_ROOT,
        id: '',
        dialogVisible: false,
        dynamicValidateForm: {
          id:'',
          workbegin:'08:00',
          workend:'18:00',
          workhours:''
        },
        tableData: [],
        form:{
          resttype: [],
          id:''
        },
        dialogVisibles:false,
        dialogVisiblePrice:false,//服务费弹窗
        priceForm:{
          id:"",
          name:"",//公司名称
          service_price:"",
          start_date:"",
          end_date:"",
        },
        priceDataList:[],//服务费历史记录
      }
    },
    activated() {
      this.getCompany()
    },
    created() {
      this.$nextTick(() => {
        document.onselectstart = new Function("event.returnValue=false");
      });
    },
    methods: {
      // 新增时间 默认8点上班 18点下班
      // dynamicValidateForm.id是外面公司列表id ， timeid是时间列表的id
      addTimes(){
        this.dialogVisibles = true ;
        this.dynamicValidateForm.id = this.form.id
        this.dynamicValidateForm.timeid = ''
        this.dynamicValidateForm.workhours = ""
        this.dynamicValidateForm.workbegin = '08:00'
        this.dynamicValidateForm.workend = '18:00'
      },
// 删除时间
      deleteTime(row){
        this.$confirm('此操作为删除此条数据, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(()=>{
                  let params = {
                    id:this.form.id,
                    timeid:row.id
                  }
                  this.post('oasystem/companyWorkTimeDelete',params).then(res=>{
                    let {code,msg} = res.data;
                    Message[code == 1?'success':'warning'](msg);
                    this.queryInfo()
                  })
                }).catch(()=>{console.log('cancle')})
      },


      handleEdit(id) {
        this.$router.push({
          path: '/oacompanyEdit?id=' + id || ''
        })
      },
// 编辑
// dynamicValidateForm.id是外面公司列表id ， timeid是时间列表的id
      editInfo(row){
        this.dynamicValidateForm = row
        this.dynamicValidateForm.workhours = Number(row.workhours)
        this.dynamicValidateForm.timeid = row.id
        this.dynamicValidateForm.id = this.form.id
        this.dialogVisibles = true
      },

// 修改
      setWorkTime(row) {
        this.dialogVisible = true;
        this.form.id = row.id;
        this.queryInfo()
      },
// 查询时间列表与工作制度
      queryInfo(){
        this.gets('oasystem/companyWorkTimeInfo?id='+this.form.id).then(res=>{
          let result = res.data;
          if(result.code == 1 ){
            this.tableData = result.data.worktime
            this.form.resttype = result.data.resttype
          }else{
            Message.warning(res.data.msg)
          }
        })
      },

// 转数字
      formatValue(e) {
        let data = this.dynamicValidateForm.workhours;
        let value = Number(data);
        this.dynamicValidateForm.workhours = isNaN(value) || value == 0 ? data : value;
      },
// 重置
      clearQuery() {
        this.key_type = '';
        this.key = ''
        this.page = 1;
        this.getCompany()
      },
      // 获取操作栏展开收缩之后的高度
      getSearchBarHeight(val) {
        let sHeight = val;
        let fHeight = this.$refs.pageTableFilter ? this.$refs.pageTableFilter.clientHeight : 0;
        this.tableInitHeight = this.$util.setTableHeight(sHeight, fHeight);
      },
      //类型查找
      searchResume() {
        if (!this.key_type) {
          return Message.warning('请选择搜索类型')
        }
        this.page = 1
        this.getCompany()
      },
      //全部列表
      getCompany() {
        this.gets('oasystem/companylist', {
            key: this.key,
            key_type: this.key_type,
            page: this.page
          })
          .then(res => {
            this.companyList = res.data.data.list;
            this.total = res.data.data.total
          })
      },

      //翻页
      handleCurrentChange(val) {
        this.page = val
        this.getCompany()
      },

      selectChange() {
        this.$forceUpdate()
      },

      //删除借支
      handleDele(id,companyname) {
        this.$confirm("是否确定删除工厂："+companyname+"?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          })
          .then(() => {
            this.gets("oasystem/companydelete?id=" + id).then((res) => {
              if (res.data.code == 1) {
                Message.success(res.data.msg)
              } else {
                Message.error(res.data.msg)
              }
              this.getCompany()
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
// 提交修改制度、修改时间、新增时间
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {}
            //  formName==form ？修改工作制度 ：新增、修改工作时间
            // dynamicValidateForm.id是外面公司列表id ， timeid是时间列表的id
            params = formName == 'form' ? this.form : this.dynamicValidateForm;
            let url = formName == 'form' ? 'oasystem/setCompanyWorkRestType' : !this.dynamicValidateForm.timeid ? 'oasystem/companyWorkTimeAdd' : 'oasystem/companyWorkTimeEdit'
            this.post(url, params).then(res => {
              let { code, data} = res.data;
              Message[code == 1 ? 'success' : 'warning'](res.data.msg)
              code == 1 ? this.page = 1 : '';
              this.queryInfo()
              code == 1 ? formName == 'form' ?  this.dialogVisible = false : this.dialogVisibles = false :'';
            })
          } else {
            return console.log('error submit!!');
          }
        });
      },
      //服务费设置弹窗 - 显示
      showPriceDialog(row) {
        this.priceForm.name = row.companyname;
        this.priceForm.id = row.id;

        this.getPriceLog();

      },
      getPriceLog() {
        let params = {id:this.priceForm.id}
        this.gets("company/servicePriceInfo", params).then(res => {
          let { code, data} = res.data;
          if(code==1) {
            this.priceForm.service_price = data.info.service_price;
            this.priceForm.start_date = data.info.start_date;
            this.priceForm.end_date = data.info.end_date;
            this.priceDataList = data.priceHistoryList;

            this.dialogVisiblePrice = true;
          }

        })
      },
      //服务费设置 - 提交
      submitFormPrice(formName) {
        if(!this.priceForm.id) {
             Message.error("请选择一个工厂");
             this.dialogVisiblePrice = false;
             return;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = this.priceForm;
            this.post("company/editServicePrice", params).then(res => {
              let { code, data} = res.data;
              Message[code == 1 ? 'success' : 'error'](res.data.msg)
              this.dialogVisiblePrice = false;
              for(let key in this.priceForm) {
                this.priceForm[key] = ""
              }
            })
          } else {
            return console.log('error submit!!');
          }
        });
      }




    }
  }
</script>

<style scoped>
  .content {
    padding: 20px 0px;
    box-sizing: border-box;
    width: 100%;
  }

  .pagination {
    margin: 20px auto;
    width: 100%;
    text-align: center;
  }

  .screen {
    display: flex;
    position: relative;
  }

  .screenList {
    display: flex;
    margin: 30px 0 10px;
  }

  .screenList .listItem {
    margin-right: 40px;
    display: flex;
    height: 40px;
    align-items: center;
  }

  .screen>>>.el-select {
    width: 100px;
  }

  .screenList>>>.el-select {
    width: 150px;
  }

  .screenTime {
    display: flex;
    margin: 20px 0;
  }

  .screenTime .items1 {
    display: flex;
    margin-right: 30px;
    height: 45px;
    align-items: center;
  }

  .remarks {
    margin: 10px 0;
  }

  .remarks .title {
    margin-bottom: 10px;
  }

  .funtion {
    margin: 20px 0;
    background-color: #fff;
    padding: 20px;
  }

  .resumeType {
    display: flex;
    height: 45px;
    align-items: center;
    font-size: 20px;
  }

  #app>>>.el-dialog {
   min-width: 750px;
  }

  .btn>.el-button {
    margin: 5px 0;
  }

  .contents {
    display: flex;
  }

  .contents .items {
    margin: 20px;
    width: 100px;
    text-align: center;
  }

  .dynamicClass>>>.el-input {
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/view/jobsManage/oacompanylist.vue